/**
 * "Remember me" persistence for the login flow.
 * Mirrors the mobile app: only the identifier is stored, never the password.
 */
import { storage } from '@wlb/shared/platform/storage';
import { STORAGE_KEYS } from '@wlb/shared/constants';

interface RememberedCredentials {
  email?: string;
  rememberMe?: boolean;
}

export async function getRememberedEmail(): Promise<string> {
  const saved = await storage.getItem<RememberedCredentials>(
    STORAGE_KEYS.REMEMBER_ME_CREDENTIALS,
  );
  return saved?.rememberMe && saved.email ? saved.email : '';
}

export async function setRememberedEmail(email: string): Promise<void> {
  await storage.setItem(STORAGE_KEYS.REMEMBER_ME_CREDENTIALS, {
    email,
    rememberMe: true,
  });
}

export async function clearRememberedEmail(): Promise<void> {
  await storage.removeItem(STORAGE_KEYS.REMEMBER_ME_CREDENTIALS);
}
